// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"styles_loadingOverlay__gC8Sz"};